import { serverErrors } from "../static/serverErrors";

export const isServerError = (error: number | unknown) => {
  if (typeof error == "number") return serverErrors.includes(error);
};
